export const now = (): Date => {
    return new Date();
};
